<template>
  <mds-modal
    size="large"
    :width="'1200px'"
    aria-label="Large Modal"
    v-model="hasOpenModel"
    title=""
    action-required
  >
    <mds-section border-position="bottom" bold>
      <template #mds-section-title>
        <span id="title-id">{{ filterInfo.title }}</span>
      </template>
      <template #mds-section-actions>
        <mds-button-container right-aligned>
          <mds-button
            v-for="element in filterInfo.actionButtons"
            :key="element.id"
            :variation="element.variation"
            type="button"
            @click="
              element.id == 1
                ? (saveButtonDialogSave_Click(),
                  $emit('buttonclick', element.method))
                : $emit('buttonclick', element.method)
            "
            >{{ element.text }}</mds-button
          >
        </mds-button-container>
      </template>

      <template>
        <mds-button-container
          name="client-button-container"
          :class="$style['button-container']"
        >
          <mds-button
            v-for="(button, index) in getButtons"
            :key="index"
            variation="secondary"
            size="small"
            :icon="button.icon"
            :Value="button.value"
            :class="[
              button.value == selectedClientId ? $style['custom-button'] : '',
              $style['custom-buttom-margins'],
            ]"
            @click.native="selectClient(button.value)"
            type="button"
          >
            <span
              v-if="button.icon == undefined"
              style="
                font-size: 11px !important;
                display: inline-block;
                color: black;
                height: 18px !important;
                width: 18px !important;
                line-height: 18px;
                text-align: center;
                border-radius: 50%;
                background-color: rgb(255, 243, 138);
              "
              :style="{ 'background-color': button.backgroundColor }"
            >
              {{ button.logoText }}
            </span>
            {{ button.buttonName }}
          </mds-button>
        </mds-button-container>
        <div :class="$style['super-edit-popup-content']">
          <div
            v-for="(datalist, headerIndex) in dataListConfig"
            :key="headerIndex"
          >
            <div :class="$style['datatablelist']" v-if="datalist.isVisible">
              <data-table-list
                :datatablelistconfig="datalist"
                @addNewRow="addNewRow"
                @eventActionHandler="eventActionHandler"
              ></data-table-list>
            </div>
          </div>
        </div>
      </template>
    </mds-section>
  </mds-modal>
</template>
<script>
import { MdsButton, MdsButtonContainer } from "@mds/button";
import _ from "lodash";
import { format } from "d3-format";
import DataTableList from "../../component/custom/data-table-list/DataTableList.vue";
import MdsModal from "@mds/modal";
import MdsSection from "@mds/section";
import {
  GET_SELECTED_SUPERANNUATION_INFORMATION,
  GET_CLIENT_INFORMATION,
} from "../../helpers/vuex-constants";
import { mapGetters } from "vuex";
import { CommonHelper } from "../../helpers";

import { currencyNumberFormat } from "../../helpers/constant";
export default {
  props: {
    isopenModel: {
      type: Boolean,
    },

    nonSuperFilterObject: {
      type: Array,
    },
  },
  components: {
    MdsModal,
    MdsSection,
    MdsButton,
    MdsButtonContainer,
    DataTableList,
  },
  data() {
    return {
      hasOpenModel: this.isopenModel,
      filterInfo: {
        title: "Edit Superannuation Details",
        borderPosition: "bottom",
        actionButtons: [
          {
            method: "closeEditSuper",
            variation: "secondary",
            text: "Cancel",
            id: "2",
          },
          {
            method: "closeEditSuper",
            variation: "primary",
            text: "Apply Changes",
            id: "1",
          },
        ],
      },
      headerInfo: {
        heading: "Manage Superannuation Accounts",
        headingIconText: "",
        subHeading:
          "Use this section to view and manage your Superannuation account details",
      },
      selectedValue: "1",
      confirmationDialogList: [
        {
          toggle: false,
          id: 1,
          message: "You are about to discard the changes you have made.",
          title: "Discard Changes",
          leftButtons: [
            {
              text: "Keep Editing",
              variation: "secondary",
              emitevent: "backButtonDialogCancel_Click",
              id: 2,
            },
          ],
          rightButtons: [
            {
              text: "Discard",
              variation: "secondary",
              emitevent: "backButtonDialogDiscard_Click",
              id: 1,
            },
            {
              text: "Save",
              variation: "primary",
              emitevent: "saveInstance",
              id: 3,
            },
          ],
        },
        {
          toggle: false,
          message: "",
          title: "Save instance",
          id: 2,
          leftButtons: [
            {
              text: "Cancel",
              variation: "secondary",
              emitevent: "saveButtonDialogCancel_Click",
              id: 1,
            },
          ],
          rightButtons: [
            {
              text: "Save",
              variation: "secondary",
              emitevent: "saveButtonDialogSave_Click",
              id: 2,
            },
            {
              text: "Save as",
              variation: "primary",
              emitevent: "saveButtonDialogSaveAs_Click",
              id: 3,
            },
          ],
        },
        {
          toggle: false,
          id: 3,
          message: "You are about to discard the changes you have made.",
          title: "Discard Changes",
          leftButtons: [
            {
              text: "Keep Editing",
              variation: "secondary",
              emitevent: "backButtonDialogCancel_Click",
              id: 2,
            },
          ],
          rightButtons: [
            {
              text: "Discard",
              variation: "secondary",
              emitevent: "cancelButtonDialogDiscard_Click",
              id: 1,
            },
            {
              text: "Save",
              variation: "primary",
              emitevent: "saveInstance",
              id: 3,
            },
          ],
        },
      ],
      initialConfigData: [],
      editModelDataList: [],

      selectedClientId: 0,
    };
  },
  mounted() {
    this.selectedClientId = this.getSelectedClientId;
  },
  async created() {},
  computed: {
    // getButtons() {
    //   if (this.selecteditem == 1) {
    //     if (this.menuCategories.filter(m => m.value == this.selecteditem)[0])
    //       return this.menuCategories.filter(m => m.value == this.selecteditem)[0].configData.buttons
    //     else
    //       return [];
    //   }
    //   return []
    // },
    getButtons() {
      let buttons = [
        { buttonName: "All Account", icon: "menu", value: 0, isActive: false },
      ];
      this.getClientInformation
        .filter((m) => [1, 2].includes(m.entityType))
        .forEach((client) => {
          buttons.push({
            buttonName: CommonHelper.toPascalCase(client.firstName),
            value: client.clientId,
            logoText: client.firstName[0].toUpperCase(),
            backgroundColor:
              client.entityType == 1 ? "#FFF38A" : "rgb(9, 158, 201)",
          });
        });
      return buttons;
    },
    ...mapGetters({
      getClientInformation: GET_CLIENT_INFORMATION,
    }),
    ...mapGetters("superannuation", {
      selectedSuperannuationData: GET_SELECTED_SUPERANNUATION_INFORMATION,
    }),
    // Left Panel
    menuCategories() {
      let menudata = [];
      let accountsConfigData = {
        buttons: this.getButtonsList(),
      };
      menudata.push(
        this.GetMenuObject(
          1,
          this.selectedValue,
          "Accounts",
          accountsConfigData
        )
      );
      return menudata;
    },
    dataListConfig() {
      if (this.editModelDataList.length == 0) {
        this.generateBlankData(this.editModelDataList);
        let superAdvanceDetails =
          this.selectedSuperannuationData.superAdvanceDetails;
        if (superAdvanceDetails) {
          superAdvanceDetails.forEach((fundDetail) => {
            fundDetail.id = Math.floor(Math.random() * 100000);
            let mainGroupObj = this.editModelDataList.filter(
              (m) => m.parentGroupId == fundDetail.clientId
            )[0];
            if (mainGroupObj != undefined) {
              this.setEdittableDataTableData(mainGroupObj, fundDetail);
            }
          });
        }
      }
      return this.editModelDataList;
    },
    //subGroup data
    getSelectedClientId() {
      return this.selectedSuperannuationData.selectClientIdForSuperFundEdit;
    },
    getHeaders() {
      return [
        {
          headerName: "Superfund Name",
          fieldType: "textwithimage",
          rowPropName: "text",
          style: {
            "vertical-align": "top",
          },
          isEditable: true,
          editableBasedOnProp: "tagName",
          isAllowOnlyNumber: false,
          maxlength: 300,
          placeholder: "Superfund Name",
        },
        {
          headerName: "",
          fieldType: "tag",
          rowPropName: "tagName",
          style: {
            width: "80px",
            "vertical-align": "top",
          },
          styleRow: {
            "text-align": "right",
            "vertical-align": "middle",
          },
        },
        {
          headerName: "Balance",
          fieldType: "text",
          rowPropName: "amount",
          sumPropName: "amount",
          formattedCurrencyLabel: "amountLabel",
          style: {
            width: "110px",
            "vertical-align": "top",
          },
          styleRow: {
            "text-align": "right",
            "vertical-align": "middle",
          },
          isEditable: true,
          isShowTotal: true,
          isAllowOnlyNumber: true,
          maxlength: 9,
          AllowOnlyDecimalTill: 0,
          currencyFormat: currencyNumberFormat,
          isEditableTextBoxRightAligned: true,
          customClassName: "alignend",
          blurValidationPropName: "text",
          inputActionEvent: "onAmountChange",
          focusoutEvent: "onSuperBalanceChange",
          keypressActionEvent: "onkeyPressTaxFree",
        },
        {
          headerName: "Taxable Component",
          fieldType: "text",
          rowPropName: "taxableComponent",
          formattedCurrencyLabel: "taxableComponentLabel",
          style: {
            width: "105px",
            "vertical-align": "top",
          },
          styleRow: {
            "text-align": "right",
            "vertical-align": "middle",
          },

          customClassName: "alignend",
        },
        {
          headerName: "Tax-free Component",
          fieldType: "text",
          rowPropName: "taxFreeComponent",
          formattedCurrencyLabel: "taxFreeComponentLabel",
          style: {
            width: "110px",
            "vertical-align": "top",
          },
          styleRow: {
            "text-align": "right",
            "vertical-align": "middle",
          },
          isEditable: true,
          isAllowOnlyNumber: true,
          maxlength: 9,
          AllowOnlyDecimalTill: 0,
          currencyFormat: currencyNumberFormat,
          isEditableTextBoxRightAligned: true,
          customClassName: "alignend",
          focusoutEvent: "onTaxFreeChange",
          inputActionEvent: "onAmountChange",
          blurValidationPropName: "text",
          disablePropName: "isDisabled",
        },
        {
          headerName: "Last Modified",
          fieldType: "text",
          rowPropName: "date",
          style: {
            width: "100px",
            "text-align": "center",
            "vertical-align": "top",
          },
          styleRow: {
            "text-align": "center",
            "vertical-align": "middle",
          },
          customClassName: "aligncenter",
        },
        {
          headerName: "Include In Calculation",
          fieldType: "checkbox",
          rowPropName: "isSelected",
          style: {
            width: "78px",
            "text-align": "center",
            "vertical-align": "top",
          },
          styleRow: {
            "text-align": "center",
            "vertical-align": "middle",
          },
        },
        {
          headerName: "",
          fieldType: "action",
          rowPropName: "isSelected",
          actions: [
            {
              emitevent: "deleteRow",
              icon: "trash",
              showActionBasedOnProp: "isShowDelete",
              toolTipText: "delete",
              position: ["top-center"],
            },
            {
              emitevent: "refreshBalance",
              icon: "refresh",
              showActionBasedOnProp: "isFactChanged",
              toolTipText: "refresh",
              position: ["top-center"],
            },
          ],
          style: {
            width: "28px",
            "text-align": "left",
            "vertical-align": "top",
          },
          styleRow: {
            "text-align": "left",
            "vertical-align": "middle",
          },
        },
      ];
    },
  },
  methods: {
    eventActionHandler(methodName, data) {
      this[methodName](data);
    },
    selectClient(clientId) {
      this.selectedClientId = clientId;
      let isVisible = false;
      if (clientId == 0) {
        isVisible = true;
      }
      this.dataListConfig.forEach((element) => {
        element.isVisible = isVisible;
      });
      if (clientId != 0)
        this.dataListConfig.filter(
          (m) => m.parentGroupId == clientId
        )[0].isVisible = true;

      if (document.querySelectorAll('[class^="super-edit-popup-content"]')[0])
        document.querySelectorAll(
          '[class^="super-edit-popup-content"]'
        )[0].scrollTop = 0;
    },
    backButtonDialogCancel_Click() {},
    genericMethodClick(function_name) {
      this[function_name]();
    },
    getCurrentRowsForChangeDetection() {
      let changedData = [];

      this.dataListConfig.forEach((data) => {
        data.editableDataTableData.forEach((editableDataTable) => {
          editableDataTable.rows.forEach((row) => {
            if (!row.isShowTotal) changedData.push(row);
          });
        });
      });
      return changedData;
    },
    redirectIfChanged(confirmBoxNumber) {
      if (
        !_.isEqual(
          this.initialConfigData,
          this.getCurrentRowsForChangeDetection()
        )
      ) {
        this.confirmationDialogList[confirmBoxNumber].toggle = true;
      } else {
        this.backButtonDialogDiscard_Click();
      }
    },
    onBack() {
      this.redirectIfChanged(0);
    },
    backButtonDialogDiscard_Click() {
      this.$router.push({ name: "superannuation-engagement-tool" });
    },
    cancelButtonDialogDiscard_Click() {
      this.$router.push({ name: "superannuation-engagement-tool" });
    },
    setEdittableDataTableData(mainGroupObj, fundDetail) {
      let subGroupData = mainGroupObj.editableDataTableData.filter(
        (m) => m.groupType == fundDetail.fundtype
      )[0];

      subGroupData.rows.push({
        text: fundDetail.superFundName,
        amountLabel: CommonHelper.convertIntoCurrencyWithoutDecimal(
          fundDetail.superFundBalance
        ),

        amount: fundDetail.superFundBalance,
        taxableComponent: fundDetail.taxableComponent,
        taxableComponentLabel: CommonHelper.convertIntoCurrencyWithoutDecimal(
          fundDetail.taxableComponent
        ),
        taxFreeComponent: fundDetail.taxFreeComponent,
        taxFreeComponentLabel: CommonHelper.convertIntoCurrencyWithoutDecimal(
          fundDetail.taxFreeComponent
        ),
        date:
          fundDetail.lastModifiedDate == null
            ? "—"
            : CommonHelper.formatDate(fundDetail.lastModifiedDate) ==
              CommonHelper.formatDate(new Date().toISOString().slice(0, 10))
            ? "Today"
            : this.formatDate(fundDetail.lastModifiedDate),
        tagName: fundDetail.isFromfact ? "FACTFIND" : "",
        isSelected: fundDetail.isIncludeContribution,
        isEditMode: false,
        superFundId: fundDetail.superFundId,
        factSuperID: fundDetail.factSuperID,
        superAdvanceGuid: fundDetail.superAdvanceGuid,
        id: fundDetail.id,
        isDeleted: false,
        isShowDelete: !fundDetail.isFromfact,
        factBalance: fundDetail.factBalance,
        factTaxfreeComponent: fundDetail.factTaxfreeComponent,
        factTaxableComponent: fundDetail.factTaxableComponent,
        isFromFact: fundDetail.isFromfact,
        isFactChanged:
          this.selectedSuperannuationData.isFromFact &&
          fundDetail.isFromfact &&
          (fundDetail.superFundBalance === fundDetail.factBalance &&
          fundDetail.taxFreeComponent == fundDetail.factTaxfreeComponent
            ? false
            : true),
        toggle: false,
        isDisabled: fundDetail.superFundBalance === 0 ? true : false,
      });
    },
    formatDate(date) {
      return CommonHelper.formatDate(date.slice(0, 10));
    },
    addNewRow(rowsGroup) {
      rowsGroup.allrows.push({
        text: "",
        amount: "0",
        amountLabel: format(currencyNumberFormat)(0),
        date: "Today",
        tagName: "",
        isSelected: true,
        isEnableTextEdit: true,
        isAllowOnlyNumber: false,
        maxlength: 300,
        isEditMode: true,
        superFundId: 0,
        factSuperID: 0,
        superAdvanceGuid: "00000000-0000-0000-0000-000000000000",
        id: 0,
        isDeleted: false,
        isShowDelete: true,
        taxableComponent: 0,
        taxableComponentLabel: format(currencyNumberFormat)(0),
        taxFreeComponent: 0,
        taxFreeComponentLabel: format(currencyNumberFormat)(0),
        toggle: false,
        isDisabled: true,
        lastModifiedDate: CommonHelper.formatDate(
          new Date().toISOString().slice(0, 10)
        ),
      });
    },
    deleteRow(deleteRowDetail) {
      deleteRowDetail.selectedRow.isDeleted = true;
    },
    setNotificationMessage(variation, message) {
      this.setNotificationSummary({
        isShow: true,
        variation: variation,
        text: message,
      });
    },
    cancelInstance() {
      this.redirectIfChanged(2);
    },
    saveInstance() {
      this.saveButtonDialogSave_Click();
      this.$router.push({ name: "superannuation-engagement-tool" });
    },
    selectfilteredMenu(data) {
      this.selectedValue = data.value;
    },
    GetMenuObject(value, active, text, data) {
      return {
        value: value,
        active: value == active,
        text: text,
        configData: data,
      };
    },

    saveButtonDialogSave_Click() {
      if (
        this.selectedSuperannuationData &&
        this.selectedSuperannuationData.superAdvanceDetails
      ) {
        //get/delete super
        const allFundDetails = this.getAllEditedDataObj();
        //updating existing funds details
        this.selectedSuperannuationData.superAdvanceDetails.forEach((fund) => {
          let updatedFund = allFundDetails.filter((m) => m.id == fund.id)[0];
          if (updatedFund) {
            fund.superFundName = updatedFund.superFundName;
            fund.superFundBalance = updatedFund.superBalance;
            fund.taxableComponent = updatedFund.taxableComponent;
            fund.taxFreeComponent = updatedFund.taxFreeComponent;
            fund.isIncludeContribution = updatedFund.isSelected;
          }
        });

        //inserting new funds
        allFundDetails
          .filter((m) => m.superFundId == 0 && m.factSuperID == 0 && m.id == 0)
          .forEach((fund) => {
            this.selectedSuperannuationData.superAdvanceDetails.push({
              superFundName: fund.superFundName,
              factSuperID: 0,
              superFundBalance: fund.superBalance,
              isFromfact: false,
              isIncludeContribution: fund.isSelected,
              clientId: fund.clientId,
              fundtype: fund.fundType,
              superAdvanceGuid: fund.superAdvanceGuid,
              superFundId: fund.superFundId,
              taxableComponent: fund.taxableComponent,
              taxFreeComponent: fund.taxFreeComponent,
              id: Math.floor(Math.random() * 100000),
              lastModifiedDate: fund.lastModifiedDate,
            });
          });
      }
    },
    getAllEditedDataObj() {
      let fundDetails = [];
      this.dataListConfig.forEach((datalist) => {
        datalist.editableDataTableData.forEach((subGroupData) => {
          subGroupData.rows
            .filter((m) => !m.isShowTotal && m.text.trim() != "")
            .forEach((row) => {
              if (!row.isDeleted) {
                fundDetails.push({
                  superFundId: row.superFundId,
                  fundType: subGroupData.groupType,
                  superFundName: row.text,
                  superBalance: row.amount,
                  isSelected: row.isSelected,
                  factSuperID: row.factSuperID,
                  clientId: datalist.parentGroupId,
                  superAdvanceGuid: row.superAdvanceGuid,
                  taxableComponent: row.taxableComponent,
                  taxFreeComponent: row.taxFreeComponent,
                  id: row.id,
                  lastModifiedDate: row.lastModifiedDate,
                });
              } else {
                if (this.selectedSuperannuationData.superAdvanceDetails) {
                  subGroupData.rows.splice(subGroupData.rows.indexOf(row), 1);

                  const deletedsuper =
                    this.selectedSuperannuationData.superAdvanceDetails.filter(
                      (m) => m.id == row.id
                    )[0];
                  if (deletedsuper) {
                    const deletedsuperindex =
                      this.selectedSuperannuationData.superAdvanceDetails.indexOf(
                        deletedsuper
                      );
                    this.selectedSuperannuationData.superAdvanceDetails.splice(
                      deletedsuperindex,
                      1
                    );
                  }
                }
              }
            });
        });
      });

      return fundDetails;
    },
    generateBlankData(editModelDataList) {
      let fundsTypes = [
        { fundType: 1, fundTypeName: "Accumulation" },
        { fundType: 2, fundTypeName: "Pension" },
      ];
      this.getClientInformation
        .filter((m) => [1, 2].includes(m.entityType))
        .forEach((client) => {
          let mainObj = {
            listTitle: client
              ? CommonHelper.toPascalCase(client.firstName)
              : "",
            isVisible:
              this.selectedSuperannuationData.selectClientIdForSuperFundEdit ==
              client.clientId
                ? true
                : false,
            parentGroupId: client.clientId,
            listDescription:
              "Please review the superannuation. Hover on row to edit amount(Superannuation added/ edited here won't be available in factfind).",
            headers: this.getHeaders,
            editableDataTableData: [],
          };
          fundsTypes.forEach((fundDetail) => {
            let subGroupData = {
              tableHeadingName: fundDetail.fundTypeName,
              groupType: fundDetail.fundType,
              emptyStateTitle:
                "No Existing " + fundDetail.fundTypeName + " Superannuation",
              emptyStateMessage:
                "Click on Add new to add " +
                fundDetail.fundTypeName.toLowerCase() +
                ", Superannuation added here won't be available in factfind",
              blankRow: {
                text: "",
                amount: "0",
                date: "Today",
                tagName: "",
                isSelected: true,
                isEnableTextEdit: true,
                isAllowOnlyNumber: false,
                maxlength: 300,
                isEditMode: true,
                superFundId: 0,
                factSuperID: 0,
              },
              rows: [],
            };
            subGroupData.rows.push({
              isShowTotal: true,
              amounts: [0, 0, 0, 0, 0],
              text: "Total Balance",
              isDeleted: false,
            });

            mainObj.editableDataTableData.push(subGroupData);
          });
          editModelDataList.push(mainObj);
        });
    },
    actionHandler(methodName, data) {
      this[methodName](data);
    },
    refreshBalance(data) {
      data.selectedRow.amount = data.selectedRow.factBalance;
      data.selectedRow.amountLabel =
        CommonHelper.convertIntoCurrencyWithoutDecimal(
          data.selectedRow.factBalance
        );

      data.selectedRow.taxableComponent = data.selectedRow.factTaxableComponent;
      data.selectedRow.taxableComponentLabel =
        CommonHelper.convertIntoCurrencyWithoutDecimal(
          data.selectedRow.factTaxableComponent
        );

      data.selectedRow.taxFreeComponent = data.selectedRow.factTaxfreeComponent;
      data.selectedRow.taxFreeComponentLabel =
        CommonHelper.convertIntoCurrencyWithoutDecimal(
          data.selectedRow.factTaxfreeComponent
        );

      data.selectedRow.isFactChanged = false;

      if (data.selectedRow.amount != 0) {
        data.selectedRow.isDisabled = false;
      } else {
        data.selectedRow.isDisabled = true;
      }
    },
    onAmountChange(data) {
      if (
        this.selectedSuperannuationData.isFromFact &&
        data.isFromFact &&
        (data.factBalance !== data.amount ||
          data.taxFreeComponent !== data.factTaxfreeComponent)
      ) {
        data.isFactChanged = true;
      } else {
        data.isFactChanged = false;
      }
    },
    onkeyPressTaxFree(data) {
      if (data.amount != 0) {
        data.isDisabled = false;
      } else {
        data.isDisabled = true;
      }
    },
    onSuperBalanceChange(data) {
      this.onTaxFreeChange(data);
    },
    onTaxFreeChange(data) {
      if (data.taxFreeComponent > data.amount) {
        data.taxFreeComponentLabel = format(currencyNumberFormat)(data.amount);
        data.taxFreeComponent = data.amount;

        data.taxableComponentLabel = format(currencyNumberFormat)(0);
        data.taxableComponent = 0;
      } else if (data.amount - data.taxFreeComponent >= 0) {
        data.taxableComponentLabel = format(currencyNumberFormat)(
          data.amount - data.taxFreeComponent
        );
        data.taxableComponent = data.amount - data.taxFreeComponent;
      } else {
        this.resetComponents(data);
      }
    },
    resetComponents(data) {
      data.taxableComponent = data.amount;
      data.taxableComponentLabel = format(currencyNumberFormat)(data.amount);
      data.taxFreeComponent = 0;
      data.taxFreeComponentLabel = format(currencyNumberFormat)(0);
    },
  },
};
</script>

<style lang="scss" module>
@import "@mds/constants";
.super-edit-popup-content {
  height: calc(90vh - 114px);
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0px 4px;
  padding-bottom: 16px;
}
.super-edit-popup-content::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
.super-edit-popup-content::-webkit-scrollbar-thumb {
  background-color: #c3d0da;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
}
.button-container {
  display: flex !important;

  .button-container button {
    height: 27px !important;
  }
}

.datatablelist {
  padding-top: $mds-space-3-x;
}

.custom-button {
  background-color: #e0ecf5 !important;
  border: 1px solid #0077cf !important;
  color: #5e5e5e !important;
}

.custom-button:hover {
  color: #5e5e5e !important;
}

.custom-buttom-margins {
  margin-right: $mds-space-2-x;
}
</style>
